module.exports = __webpack_public_path__ + "img/hero.bad8692e.png";